export const T = {
  en_GB: {
    /**
     * Headings for the feedback cards.
     *
     * Deliberately factual: the heading says where the message came from and what
     * the outcome was, and nothing more. Every card looks the same — red heading,
     * message icon, left accent — so the wording must not imply that a card means
     * "rejected" or "can be reopened". Those are separate, independent facts.
     */
    heading: {
      compliance_rejected: "Compliance rejected",
      external_rejected: "External review rejected",
      drafted: "Returned for changes",
      cancelled: "Advice cancelled",
      compliance_review_flagged: "Compliance review · flagged",
      compliance_review_remark: "Compliance review · remark",
    },
    // Suffix appended to the heading of feedback a later submission moved past.
    historicalSuffix: "Previous submission",
    noComment: "No comment provided",
    // The same instruction on every card of a locked, reopenable flow.
    reopenInstruction: "Reopen the flow to update the advice, then submit it again.",
    dismiss: "Dismiss for everyone",
    showMore: "Show more",
    showLess: "Show less",
  },
  nb_NO: {
    heading: {
      compliance_rejected: "Compliance avviste",
      external_rejected: "Ekstern gjennomgang avviste",
      drafted: "Sendt tilbake for endringer",
      cancelled: "Råd kansellert",
      compliance_review_flagged: "Compliance-gjennomgang · flagget",
      compliance_review_remark: "Compliance-gjennomgang · merknad",
    },
    historicalSuffix: "Forrige innsending",
    noComment: "Ingen kommentar oppgitt",
    reopenInstruction: "Gjenåpne flyten for å oppdatere rådet, og send det inn på nytt.",
    dismiss: "Skjul for alle",
    showMore: "Vis mer",
    showLess: "Vis mindre",
  },
} as const;
